export default "__VITE_ASSET__UQK597fK__"